/**
 * In-memory store for the temporary password used during forced password change.
 * The login screen stores the password here so the change-password screen can
 * send it to the backend without asking the user to re-enter it.
 * Never persisted — cleared after use or on logout.
 */
let _password: string | null = null;

export const tempPasswordStore = {
  set: (password: string) => {
    _password = password;
  },
  get: () => _password,
  clear: () => {
    _password = null;
  },
};
